module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Db-Ef-Gb.dda9fbf7.png";